// Copy to Constants.tsx (gitignored). Use MODE = "dev" locally, "prod" on server.
let MODE = "prod";

export const CURRENT_HOST =
    MODE === "dev"
        ? "http://localhost:5000"
        : "https://solarbasupport.org"; // production: empty string = API on same domain as UI

export const isMobile = window.screen.width < 768;
